import { Routes } from '@angular/router';
import { DonationsAdminComponent } from './components/donations-admin/donations-admin.component';

export const DONATION_ROUTES: Routes = [{
	path: 'Donation', component: DonationsAdminComponent
}];
